var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChromiumIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4445_6206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.003 300.001L429.91 374.999L300.003 599.999C465.688 599.999 600.002 465.686 600.002 300.001C600.002 245.341 585.312 194.141 559.769 150H300L300.003 300.001Z",
    fill: "url(#paint0_linear_4445_6206)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.998 0C188.959 0 92.0851 60.369 40.2109 150.037L170.091 375.001L299.998 300.002V150.001H559.767C507.884 60.3557 411.023 0 299.998 0Z",
    fill: "url(#paint1_linear_4445_6206)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00177166 300.005C0.00177166 465.689 134.311 600.003 300.001 600.003L429.908 375.003L300.001 300.005L170.094 375.003L40.214 150.039C14.6857 194.167 0 245.349 0 300",
    fill: "url(#paint2_linear_4445_6206)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.004 300.001C450.004 382.843 382.844 450.002 300.002 450.002C217.159 450.002 150 382.843 150 300.001C150 217.159 217.159 150 300.002 150C382.844 150 450.004 217.159 450.004 300.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.878 300.001C421.878 367.311 367.311 421.877 300.002 421.877C232.692 421.877 178.125 367.311 178.125 300.001C178.125 232.692 232.692 178.125 300.002 178.125C367.311 178.125 421.878 232.692 421.878 300.001Z",
    fill: "url(#paint3_linear_4445_6206)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4445_6206",
    x1: 450.642,
    y1: 149.381,
    x2: 450.001,
    y2: 599.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFCCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BB5F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4445_6206",
    x1: 256.491,
    y1: 4.57071,
    x2: 281.287,
    y2: 407.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1972E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1969D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4445_6206",
    x1: 214.954,
    y1: 150.039,
    x2: 214.954,
    y2: 600.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#659CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4445_6206",
    x1: 298.759,
    y1: 178.589,
    x2: 300.002,
    y2: 421.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3680F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2678EC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4445_6206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromiumIcon);
export default __webpack_public_path__ + "static/media/chromium_icon.7eb76f74fc055b261c6f87331c102253.svg";
export { ForwardRef as ReactComponent };